"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TaskRuleList',
  emits: ['saved'],
  data: function data() {
    return {
      list: [],
      loading: false,
      page: 1,
      limit: 10,
      total: 0,
      editDrawerVisible: false,
      editForm: {
        id: null,
        ruleCode: '',
        ruleName: '',
        ruleText: ''
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _taskConfig.fetchTaskRuleList)({
        page: this.page,
        limit: this.pageSize
      }).then(function (response) {
        _this.list = response.records || [];
        _this.total = response.total || 0;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    handleEdit: function handleEdit(row) {
      // 跳转或弹窗编辑逻辑
      this.editForm = _objectSpread({}, row); // 浅拷贝，避免直接修改表格数据
      this.editDrawerVisible = true;
    },
    submitEdit: function submitEdit() {
      var _this2 = this;
      // 可调用保存接口（如 updateTaskRule(this.editForm)）
      console.log('提交修改数据', this.editForm);
      (0, _taskConfig.updateTaskRule)(this.editForm).then(function (res) {
        _this2.$message.success('保存成功');
        _this2.editDrawerVisible = false; // 停止加载
      }).catch(function () {
        _this2.$message.error('保存失败');
        _this2.editDrawerVisible = false; // 停止加载
      });
      this.getList();
    },
    formatRuleType: function formatRuleType(row) {
      return row.ruleType === 'single' ? '单次' : '循环';
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.limit = newSize;
      this.page = 1;
      this.getList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.page = newPage;
      this.getList();
    }
  }
};